module.exports = __webpack_public_path__ + "img/325.48cfb46a.png";